import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page = Loadable(() =>
  import(
    /* webpackChunkName: "business-product-eye-wear" */ './index'
    )
);

export default prerenderedLoadable(Page);
